import React, { lazy, Suspense } from 'react';
import {
    Routes,
    Route,
    Navigate,
    useLocation
} from 'react-router-dom';
import { useAppSelector } from 'hooks/useStore';

// const Landing = lazy(() => import('pages/public/Landing'));
// const Courses = lazy(() => import('pages/public/Courses'));
// const CourseInfo = lazy(() => import('pages/public/CourseInfo'));
// const FullSATLevelTest = lazy(() => import('pages/public/FullSATLevelTest'));
// const Profile = lazy(() => import('pages/private/Profile'));
// const Classroom = lazy(() => import('pages/private/Classroom'));
// const Course = lazy(() => import('pages/private/Course'));
// const Test = lazy(() => import('pages/private/Test'));
// const TestReport = lazy(() => import('pages/private/TestReport'));
// const Cart = lazy(() => import('pages/private/Cart'));
// const Checkout = lazy(() => import('pages/private/Checkout'));
// const PaymentConfirm = lazy(() => import('pages/private/PaymentConfirm'));
// const StripeConfirm = lazy(() => import('pages/private/PaymentConfirm/StripeConfirm'));
// const Quiz = lazy(() => import('pages/private/Quiz'));
// const QuizResult = lazy(() => import('pages/private/Quiz/Result'));

import SAT from 'pages/private/Tests/SAT';
import Profile from 'pages/private/Profile';
import DigitalSAT from 'pages/private/DigitalSAT';
import DigitalACT from 'pages/private/DigitalACT';
import DigitalSATReport from 'pages/private/DigitalSAT/DigitalSATReport';
import DigitalSATReview from 'pages/private/DigitalSAT/DigitalSATReview';
import DigitalACTReport from 'pages/private/DigitalACT/DigitalACTReport';
import DigitalACTReview from 'pages/private/DigitalACT/DigitalACTReview';
import HistoricalReport from 'pages/private/HistoricalReport';
import Cart from 'pages/private/Cart';
import Checkout from 'pages/private/Checkout';
import PaymentConfirm from 'pages/private/PaymentConfirm';
import StripeConfirm from 'pages/private/PaymentConfirm/StripeConfirm';
import NotFound from 'pages/error/NotFound';
import Unauthorized from 'pages/error/Unauthorized';
import ServerError from 'pages/error/ServerError';

function PrivateRoutes() {
    const { bundles } = useAppSelector(state => state.cart);
    const { status } = useAppSelector(state => state.error);
    
    const { state } = useLocation() as {
        state?: { referrer?: string; }
    };

    if (status === 401) return <Unauthorized />;
    else if (status !== null) return <ServerError />;

    return (
        <Suspense fallback={<></>}>
            <Routes>
                <Route path='/' element={<Navigate to='/tests/digital-sat' />} />
                <Route path='/account' element={<Profile />} />
                <Route path='/tests/digital-sat' element={<SAT />} />
                {/* <Route path='/tests/digital-psat' element={<PSAT />} /> */}
                {/* <Route path='/tests/digital-sat/historicalReport' element={<HistoricalReport />} /> */}
                <Route path='/digital/sat/:testId' element={<DigitalSAT />} />
                <Route path='/digital/act/:testId' element={<DigitalACT />} />
                <Route path='/report/digital-sat/:testId' element={<DigitalSATReport />} />
                <Route path='/review/digital-sat/:testId' element={<DigitalSATReview />} />
                <Route path='/report/digital-act/:testId' element={<DigitalACTReport />} />
                <Route path='/review/digital-act/:testId' element={<DigitalACTReview />} />
                <Route path='/cart' element={<Cart />} />
                <Route path='/checkout' element={bundles.length > 0 
                    ? <Checkout /> 
                    : <Navigate to='/cart' replace />
                } />
                <Route path='/payment/stripe' element={<StripeConfirm />} />
                <Route path='/payment/:paymentId' element={<PaymentConfirm />} />

                <Route path='/signin' element={<Navigate to={state?.referrer
                    ? state.referrer
                    : '/'
                } replace />} />

                <Route path='*' element={<NotFound />} />
            </Routes>
        </Suspense>
    );
}

export default PrivateRoutes;
